<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
    :class="{
      rtl: $i18n.locale === 'fa' || $i18n.locale === 'ar',
      ltr: $i18n.locale === 'en',
    }"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col
            v-for="(item, index) in computedValue.items"
            :key="index"
            class="pa-2"
            cols="12"
          >
            <v-card class="rounded-lg pa-2 d-flex align-center">
              <create-personnel v-model="computedValue.items[index]" />
              <div class="d-flex flex-column justify-center align-center">
                <v-btn
                  :disabled="index === 0"
                  icon
                  small
                  @click.stop="moveUp(index)"
                >
                  <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
                <v-btn icon small @click.stop="removePersonnel(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <help-info
                  v-if="index === -1"
                  :element-name="`${serviceName}-${componentName}-computedValue-${index}`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('personnel.team_members')"
                />
                <v-btn
                  :disabled="index === computedValue.items.length - 1"
                  icon
                  small
                  @click.stop="moveDown(index)"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-card-actions>
          <div class="rowinfo" style="width: 100% !important">
            <v-btn
              color="success"
              outlined
              @click="addPersonnel"
              class="contentinfo"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("personnel.add_team_member") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-addPersonnel`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('personnel.add_team_member')"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import CreatePersonnel from "@/view/components/Personnel/CreatePersonnel";

export default {
  name: "Personnel",
  components: { CreatePersonnel },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "personnel-index",
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    addPersonnel() {
      const newItem = {
        position: this.$t("personnel.default_position"),
        phone: this.$t("personnel.default_phone"),
        full_name: this.$t("personnel.default_full_name"),
        description: this.$t("personnel.default_description"),
        image: [
          {
            name: "",
            images: [
              {
                name: "4 (1)",
                title: "",
                url: this.$cdnUrl + "/upload/646f131b4d1d0.webp",
                description: "",
                link: "",
                id: 7857,
              },
            ],
          },
        ],
      };
      // استفاده از spread برای اطمینان از reactiveness
      this.computedValue = {
        ...this.computedValue,
        items: [...this.computedValue.items, newItem],
      };
    },
    moveUp(index) {
      if (index === 0) return;
      const items = [...this.computedValue.items];
      [items[index], items[index - 1]] = [items[index - 1], items[index]];
      this.computedValue = {
        ...this.computedValue,
        items,
      };
    },
    moveDown(index) {
      if (index === this.computedValue.items.length - 1) return;
      const items = [...this.computedValue.items];
      [items[index], items[index + 1]] = [items[index + 1], items[index]];
      this.computedValue = {
        ...this.computedValue,
        items,
      };
    },
    removePersonnel(index) {
      const items = [...this.computedValue.items];
      items.splice(index, 1);
      this.computedValue = {
        ...this.computedValue,
        items,
      };
    },
  },
};
</script>

<style scoped>
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
.v-card {
  transition: all 0.3s;
}
.v-btn {
  margin: 4px 0;
}
</style>
